import React, { Fragment, useEffect } from 'react';
import { renderFileActionBtns as renderActionButtons } from '../admin';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { I } from '../../../common/v5/config';
import {
  ListHeaderWrapper,
  ListContentWrapper,
  TableHeader,
  editorTitleByView,
  EditorHeader,
  AdminListAndEditLayout,
  withEditWrap,
} from '../../../reactcomponents/Admin';
import {
  ADMIN_TITLE,
  M_PTT_WIDGET_CONFIG,
} from '../../../common/v5/constants';
import PttWidgetConfigForm from './pttWidgetConfigEdit';
import { customPageTotal } from '../../../reactcomponents/Table';

const EditForm = withEditWrap(PttWidgetConfigForm);

const PttWidgetConfig = ({
  view,
  onLoad,
  showInline,
  list,
  onLoadToEdit,
  onChangeAdminInput,
  onSaveAdmin,
  onDeleteFromList,
  onCloseForm,
  activeId,
  input,
  adminStatus
}) => {
  const isNew = activeId <= 0;

  useEffect(() => {
    if (onLoad) {
      onLoad(M_PTT_WIDGET_CONFIG, false);
    }
  }, []);

  const handleDelete = (id) => {
    let confirmDelMsg = I('Are you sure you want to delete?');
    if (confirm(confirmDelMsg)) {
      onDeleteFromList(id);
    }
  }

  const handleTextInputChange = (e) => {
    const field = e.target.name;
    const value = e.target.value;
    onChangeAdminInput(field, value);
  }

  const resetInputFields = () => {
    // Reset all input fields to empty/default values
    const fieldsToReset = [
      'name', 'widgetId', 'sipQueueId', 'voiceUrl', 'customize', 
      'buttonText', 'buttonColor', 'buttonSize'
    ];
    
    fieldsToReset.forEach(field => {
      const defaultValue = field === 'customize' ? false : '';
      onChangeAdminInput(field, defaultValue);
    });
  }

  // Reset input fields when creating new entry
  useEffect(() => {
    if (isNew && showInline) {
      resetInputFields();
    }
  }, [isNew, showInline]);

  const actionDatas = {
    onDelete: onDeleteFromList,
    onEdit: onLoadToEdit
  }
  const columns = [
    {
      dataField: 'id',
      text: 'ID',
      sort: true,
      hidden: true
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
    },
    {
      dataField: 'widgetId',
      text: 'Widget ID',
      sort: true,
    },
    {
      dataField: 'sipQueueId',
      text: 'SIP Queue ID',
      sort: true,
    },
    {
      isDummyField: true,
      dataField: 'action',
      text: 'Action',
      headerClasses: 'center',
      formatter: (cell, row) => {
        return renderActionButtons(cell, row, actionDatas);
      },
    }
  ];

  const defaultSorted = [{
    dataField: 'createtime',
    order: 'desc'
  }];

  const options = {
    paginationSize: 3,
    pageStartIndex: 1,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    firstPageText: '<<',
    prePageText: '<',
    nextPageText: '>',
    lastPageText: '>>',
    showTotal: true,
    paginationTotalRenderer: customPageTotal,
    disablePageTitle: true,
    sizePerPageList: [10]
  };

  // If we're editing, show only the edit section with original styling
  if (showInline) {
    return (
      <div className="app-inner-content">
        <EditorHeader
          hidden={false}
          isNew={isNew}
          onClickClose={onCloseForm}
          title={editorTitleByView(isNew, view)}
        />
        <EditForm
          activeId={activeId}
          input={input}
          view={view}
          onChangeAdminInput={onChangeAdminInput}
          onSaveAdmin={onSaveAdmin}
          onCancel={onCloseForm}
          onDelete={handleDelete}
          isNew={isNew}
          hidden={false}
          adminStatus={adminStatus}
          onHandleTextInputChange={handleTextInputChange}
        />
      </div>
    );
  }

  // If not editing, show only the list section
  let listSection = <Fragment>
    <ListHeaderWrapper>
      <TableHeader
        title={ADMIN_TITLE[view]}
        type='button'
        iconClass='icon-add'
        onClickAdd={e => onLoadToEdit(0)}
        hide={false}
        hideAddIcon={false}
        showInline={showInline}
      />
    </ListHeaderWrapper>
    <ListContentWrapper className={"v5-table-style"}>
      <BootstrapTable
        keyField="id"
        data={list}
        noDataIndication={I("No data to display")}
        columns={columns}
        bordered={false}
        condensed={false}
        defaultSorted={defaultSorted}
        pagination={paginationFactory(options)}
        hover
      />
    </ListContentWrapper>
  </Fragment>;

  let editSection = <Fragment>
    <EditorHeader
      hidden={!showInline}
      isNew={isNew}
      onClickClose={onCloseForm}
      title={editorTitleByView(isNew, view)}
    />
    <EditForm
      activeId={activeId}
      input={input}
      view={view}
      onChangeAdminInput={onChangeAdminInput}
      onSaveAdmin={onSaveAdmin}
      onCancel={onCloseForm}
      onDelete={handleDelete}
      isNew={isNew}
      hidden={!showInline}
      adminStatus={adminStatus}
      onHandleTextInputChange={handleTextInputChange}
    />
  </Fragment>;

  return (
    <AdminListAndEditLayout
      className={"app-inner-content"}
      listSection={listSection}
      editSection={editSection}
    />
  );
}

export default PttWidgetConfig; 
